import { render, staticRenderFns } from "./ModalLogReserva.vue?vue&type=template&id=203bfdb8&"
import script from "./ModalLogReserva.vue?vue&type=script&lang=js&"
export * from "./ModalLogReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports